export enum NRadioGroupDirection {
  Row = 'row',
  Column = 'column'
}
